if (!customElements.get('main-blog')) {
  customElements.define(
    'main-blog',
    class extends HTMLElement {
      constructor() {
        super();

        const grids = Array.from(this.querySelectorAll('[data-article-grid]'));

        this.first = grids[0] || null;
        this.last = grids[grids.length - 1] || this.first;

        this.previousPage = this.first?.getAttribute('data-article-grid-previous') || null;
        this.nextPage = this.last?.getAttribute('data-article-grid-next') || null;

        const loadButtons = Array.from(this.querySelectorAll('[data-load-more]'));

        this.loadPrevious = null;
        this.loadNext = null;

        if (loadButtons.length === 1) {
          const [button] = loadButtons;

          this.loadPrevious = this.previousPage && !this.nextPage ? button : null;
          this.loadNext = this.nextPage ? button : null;
        } else if (loadButtons.length > 1) {
          [this.loadPrevious, this.loadNext] = loadButtons;
        }

        this.controller = null;
      }

      connectedCallback() {
        this.loadNext?.addEventListener('click', () => {
          if (this.nextPage) {
            this.reloadSection(this.nextPage, 'next');
          }
        });

        this.loadPrevious?.addEventListener('click', () => {
          if (this.previousPage) {
            this.reloadSection(this.previousPage, 'previous');
          }
        });
      }

      /**
       * Reloads the section with the next or previous page
       * @param {string} page - The page to load
       * @param {'next' | 'previous'} direction - Direction to load
       * @returns {Promise<JSON | null>} The response
       */
      async reloadSection(page, direction) {
        if (!page) return null;

        if (this.controller) {
          this.controller.abort();
        }

        this.controller = new AbortController();
        const signal = this.controller.signal;

        const config = {
          method: 'GET',
          signal,
        };

        this.dataset.loading = 'true';

        try {
          const response = await fetch(`${page}&sections=section-main-blog`, config).catch((error) => {
            if (error.name === 'AbortError') {
              return null;
            }

            throw error;
          });

          if (!response) return null;

          const data = await response.json();

          if (response.ok) {
            if (data['section-main-blog']) {
              const html = new DOMParser().parseFromString(data['section-main-blog'], 'text/html');
              const component = Array.from(html.querySelectorAll('[data-article-grid]')).pop();

              const target = direction === 'previous' ? this.first : this.last;

              if (component && target) {
                const cards = Array.from(component.querySelectorAll('.article-card'));

                cards.forEach((card) => {
                  card.setAttribute('data-loading', 'true');

                  /** @type {HTMLImageElement | null} */
                  const image = card.querySelector('.article-card-media img');

                  if (image) {
                    image.onload = () => {
                      card.removeAttribute('data-loading');
                      card.setAttribute('data-loaded', 'true');
                    };
                  }
                });

                history.pushState({}, '', page);

                if (direction === 'previous') {
                  target.before(component);
                  this.first = component;
                  this.previousPage = this.first?.getAttribute('data-article-grid-previous') || null;

                  if (!this.previousPage && this.loadPrevious) {
                    this.loadPrevious.remove();
                    this.loadPrevious = null;
                  }
                } else {
                  target.after(component);
                  this.last = component;
                  this.nextPage = this.last?.getAttribute('data-article-grid-next') || null;

                  if (!this.nextPage && this.loadNext) {
                    this.loadNext.remove();
                    this.loadNext = null;
                  }
                }
              }
            }

            return data;
          }

          throw new Error(response.statusText || 'Failed to reload blog section');
        } finally {
          this.dataset.loading = 'false';
        }
      }
    },
  );
}
